import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CertificatedPage } from './certificated';
import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    CertificatedPage,
  ],
  imports: [
    IonicPageModule.forChild(CertificatedPage),
    BrMaskerModule,
  ],
})
export class CertificatedPageModule { }



// WEBPACK FOOTER //
// ./src/pages/certificated/certificated.module.ts